import { render, staticRenderFns } from "./RefundTable.vue?vue&type=template&id=2448a105&scoped=true"
import script from "./RefundTable.vue?vue&type=script&lang=js"
export * from "./RefundTable.vue?vue&type=script&lang=js"
import style0 from "./RefundTable.vue?vue&type=style&index=0&id=2448a105&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2448a105",
  null
  
)

export default component.exports